module.exports = __webpack_public_path__ + "img/completion8.e87dec81.svg";